import moment from 'moment';

const name = 'IznvOpeningHours';

const weekDayOptions = [
    {title: '日曜日', value: 0},
    {title: '月曜日', value: 1},
    {title: '火曜日', value: 2},
    {title: '水曜日', value: 3},
    {title: '木曜日', value: 4},
    {title: '金曜日', value: 5},
    {title: '土曜日', value: 6},
]

const stringHtml = (openingHours, businessDays) => {
    return openingHoursString(openingHours) + businessDaysString(businessDays);
}

const openingHoursString = (openingHours) => {
    if(!openingHours || openingHours.length === 0) return '営業時間設定なし<br>';
    let html = '<span class="d-flex flex-wrap"><span>[営業時間]　</span>';
    for(const data of openingHours) {
        html += '<span>' + openingHourString(data) + '　</span>';
    }
    html += '</span>';
    return html;
}

const businessDaysString = (businessDays) => {
    if(!businessDays || businessDays.length === 0) return '営業日・休業日設定なし<br>';
    let html = '';
    const closingDays = businessDays.filter(day => day.condition === 'close');
    const openingDays = businessDays.filter(day => day.condition === 'open');
    if(closingDays.length > 0) {
        html += '<span class="d-flex flex-wrap"><span>[休業日]　</span>';
        for(const data of closingDays) {
            html += '<span>' + businessDayString(data) + '　</span>';
        }
        html += '</span>';
    }
    if(openingDays.length > 0) {
        html += '<span class="d-flex flex-wrap"><span>[営業日]　</span>';
        for(const data of openingDays) {
            html += '<span>' + businessDayString(data) + '　</span>';
        }
        html += '</span>';
    }
    return html;
}

const openingHourString = (data, closing = false) => {
    if(data.text?.length) return ' ' + data.text;
    if(!closing) {
        const lastOrderString = data.close === data.last_order ? "" : '（ラストオーダー ' + timeString(data.last_order) + '）';
        return timeString(data.open) + '〜' + timeString(data.close) + lastOrderString;
    } else return timeString(data.open) + '〜' + timeString(data.close);
}

const timeString = (periodNum) => {
    const hour = Math.floor(periodNum / 100);
    const minute = periodNum % 100;
    return (hour >= 24 ? '翌日' + (hour - 24) : hour) + ':' + ('0' + minute).slice(-2);
}

const businessDayString = (data) => {
    let html = '';
    if(data.repeat === 'weekly') {
        html += '毎週';
        data.week_days.forEach(weekDay => {
            html += weekDayOptions.find(option => option.value === weekDay).title + '、';
        });
        html = html.slice(0, -1);
    } else if(data.repeat === 'monthly' || data.repeat === 'monthly_by_day') {
        html += '毎月';
        if(data.repeat === 'monthly') {
            data.month_weeks.forEach(monthWeek => {
                html += '第' + monthWeek + '、';
            });
            html = html .slice(0, -1);
            data.week_days.forEach(weekDay => {
                html += weekDayOptions.find(option => option.value === weekDay).title + '、';
            });
            html = html .slice(0, -1);
        } else {
            data.month_days.forEach(monthDay => {
                html += monthDay + '日、';
            });
            html = html .slice(0, -1);
        }
    } else if(data.repeat === 'day') {
        html += moment(data.day).format('YYYY年M月D日');
    } else if(data.repeat === 'period') {
        html += moment(data.period.start).format('YYYY年M月D日') + 'から' + moment(data.period.end).format('YYYY年M月D日');
    }
    if(!data.hours_default) {
        data.opening_hours.forEach(openingHour => {
            html += '';
            html += openingHourString(openingHour, data.condition === 'close');
        });
    }
    return html;
}

const checkOpeningHour = (data, now, nowClosed = true) => {
    const compareCondition = nowClosed ? '[)' : '()';//'open始まり close終わり' 'close始まり open終わり'
    const open = moment(now).hour(data.open / 100).minute(data.open % 100);
    const closeTomorrow = data.last_order >= 2400;
    const close = moment(now).hour((data.last_order % 2400) / 100).minute(data.last_order % 100);
    if(!closeTomorrow) return now.isBetween(open, close, 'minute', compareCondition);
    else return now.isBetween(open.clone().subtract(1, 'day'), close, 'minute', compareCondition) || now.isBetween(open, close.clone().add(1, 'day'), 'minute', compareCondition);
}
const checkOpeningHours = (openingHours, now) => {
    let result = false;
    opengingHours.forEach(openingHour => {
        if(result) return;
        result = checkOpeningHour(openingHour, now);
    });
    return result;
}
const overNight = (openingHour, now) => {
    return openingHour.last_order >= 2400 && (now.hour() * 100 + now.minute()) < (openingHour.last_order - 2400);
}
const checkBusinessDay = (data, defaultOpeningHours, now, totalResult, nowClosed = true) => {
    let result = false;
    const hoursData = data.hours_default ? defaultOpeningHours : data.opening_hours;
    const yesterday = now.clone().subtract(1, 'day');
    if(data.repeat === 'weekly') {
        data.week_days.forEach(weekDay => {
            if(result) return;
            if(hoursData.length) hoursData.forEach(openingHour => {
                if(result) return;
                let weekDayNow = now.day();
                if(overNight(openingHour, now)) weekDayNow = yesterday.day();
                const openingHourCheck = (data.condition === 'close' && data.hours_default) ? true : checkOpeningHour(openingHour, now);
                result = (weekDayNow === weekDay && openingHourCheck);
            });
            else result = (now.day() === weekDay);
        })
    } else if(data.repeat === 'monthly') {
        console.log('it is monthly data: ', data);
        data.month_weeks.forEach(monthWeek => {
            if(result) return;
            data.week_days.forEach(weekDay => {
                if(result) return;
                if(hoursData.length) hoursData.forEach(openingHour => {
                    if(result) return;
                    let weekDayNow = now.day();
                    let monthDateNow = now.date();
                    if(overNight(openingHour, now)) {
                        weekDayNow = yesterday.day();
                        monthDateNow = yesterday.date();
                    }
                    const openingHourCheck = (data.condition === 'close' && data.hours_default) ? true : checkOpeningHour(openingHour, now);
                    result = (weekDayNow === weekDay && (Math.floor(monthDateNow / 7) + 1) === monthWeek && openingHourCheck);
                    console.log('checkBusinessDay result: ', result, (Math.floor(monthDateNow / 7) + 1), monthWeek);
                });
                else result = (now.day() === weekDay && (Math.floor(now.date() / 7) + 1 === monthWeek));
            });
        });
    } else if(data.repeat === 'monthly_by_day') {
        data.month_days.forEach(monthDay => {
            if(result) return;
            if(hoursData.length) hoursData.forEach(openingHour => {
                if(result) return;
                let monthDateNow = now.date();
                if(overNight(openingHour, now)) monthDateNow = yesterday.date();
                const openingHourCheck = (data.condition === 'close' && data.hours_default) ? true : checkOpeningHour(openingHour, now);
                result = monthDateNow === monthDay && openingHourCheck;
            });
            else result = now.date() === monthDay;
        });
    } else if(data.repeat === 'day') {
        if(hoursData.length) hoursData.forEach(openingHour => {
            if(result) return;
            let theDate = now;
            if(overNight(openingHour, now)) theDate = yesterday;
            const openingHourCheck = (data.condition === 'close' && data.hours_default) ? true : checkOpeningHour(openingHour, now);
            result = theDate.isSame(moment(data.day), 'day') && openingHourCheck;
        });
        else result = theDate.isSame(moment(data.day), 'day');
    } else if(data.repeat === 'period') {
        if(hoursData.length) hoursData.forEach(openingHour => {
            if(result) return;
            let theDate = now;
            if(overNight(openingHour, now)) theDate = yesterday;
            const openingHourCheck = (data.condition === 'close' && data.hours_default) ? true : checkOpeningHour(openingHour, now);
            result = theDate.isBetween(data.period.start, data.period.end, 'day', '[]') && openingHourCheck;
        });
        else result = theDate.isBetween(data.period.start, data.period.end, 'day', '[]');
    }
    if(totalResult && data.condition === 'close') totalResult = !result;
    else if(!totalResult && data.condition === 'open') totalResult = result; 
    return totalResult;
}
const checkOpen = (openingHours, businessDays, now = null, nowClosed = true) => {
    if(!now) now = moment();
    // console.log('checkOpen now: ', now.format());
    let result = (openingHours && openingHours.length) ? false : true;
    if(!result) openingHours.forEach(openingHour => {
        if(result) return;
        result = checkOpeningHour(openingHour, now, nowClosed);
        // const open = moment({
        //     hour: openingHour.open / 100,
        //     minute: openingHour.open % 100
        // });
        // const closeTomorrow = openingHour.last_order >= 2400;
        // const close = moment({
        //     hour: (openingHour.last_order % 2400) / 100,
        //     minute: openingHour.last_order % 100
        // });
        // let itemResult;
        // if(!closeTomorrow) itemResult = now.isBetween(open, close);
        // else itemResult = now.isBetween(open.clone().subtract(1, 'day'), close) || now.isBetween(open, close.clone().add(1, 'day'));
        // result ||= itemResult;
    });
    if(businessDays && businessDays.length) businessDays.forEach(businessDay => {
        result = checkBusinessDay(businessDay, openingHours, now, result, nowClosed);
    });
    // console.log('IznvOpeningHours.checkOpen called. result: ', result);
    return result;
}
const nextOpenTime = (openingHours, businessDays, nowClosed = true) => {
    const nextTime = moment();
    nextTime.locale('ja');
    let i = 0;
    let checked = nowClosed;
    // console.log('nextOpenTime openingHours, businessDays: ', openingHours, businessDays);
    while(checked === nowClosed && i < 12 * 24 * 7) {
        nextTime.add(5, 'minute');
        checked = !checkOpen(openingHours, businessDays, nextTime, nowClosed);
        i++;
        // console.log('nextOpenTime i: ', i, nextTime.format('M月D日k:mm'), checked, nowClosed);
    }
    nextTime.subtract(nextTime.minute() % 5, 'minute').seconds(0).milliseconds(0);
    // console.log('nextOpenTime i, nextTime: ', i, nextTime.format());
    return i < 12 * 24 * 7 ? nextTime : false;
}
const nextOpenTimeString = (nextOpenTime, nowClosed = true) => {
    const condition = nowClosed ? '開始' : '終了';
    if(!nextOpenTime) return '次の' + condition + '：1週間以上先';
    const timeToGo = nextOpenTime.diff(moment(), 'minutes') + 1;
    // const prefix = timeToGo > 30 * 60 * 1000 ? '次の' : 'もうすぐ';
    const comingSoon = timeToGo <= 30;
    const prefix = comingSoon ? 'もうすぐ' : '';
    const sameDay = nextOpenTime.isSame(moment(), 'day');
    const nextDay = nextOpenTime.isSame(moment().add(1, 'day'), 'day');
    // const format = sameDay ? 'H:mm' : 'M月D日(dd)H:mm';
    const format = sameDay ? 'H:mm' : (nextDay ? '明日' : 'dd曜日') + 'H:mm';
    const displayString = comingSoon ? ('あと' + timeToGo + '分') : nextOpenTime.format(format);
    return prefix + condition + '：' + displayString;
}

export default {
    name: name,
    stringHtml: stringHtml,
    checkOpen: checkOpen,
    nextOpenTime: nextOpenTime,
    nextOpenTimeString: nextOpenTimeString,
}

